<template>
  <div class="chatItemsComponent outcontent">
    <div v-if="statement.length > 0" class="alert" :class="showAlert" role="alert" v-html="convertStatement">
    </div>
    <div class="titleBox">
      <div class="title">
        <h2 style="display: none">{{ titleh1 }}</h2>

        {{ title }}<div class="prompt"><img :src="'img/pic/prompt.svg'" alt=""></div>
      </div>
      <div class="sub-title">
        <div class="promptLine">
歡迎提出您自身的相關問題，我們合作的治療師會盡快回覆您！
          <div class="promptBtn">
            <a v-if="authCheck" :href="'onlineMedicalConsultation/newCreate'">提出新問題</a>
            <a v-else :href="'user/login'">提出新問題(請先登入會員)</a>
          </div>
        </div>
        <div v-if="pageType != 'list'" class="promptLine margin-l-auto">
          <div class="promptBtn more show">
            <a v-if="canReply" @click="toggleNewReplay">新回覆</a>
          </div>
        </div>
        <div class="promptLine">
          <div class="more" :class="showMore"><a :href="'onlineMedicalConsultation'">更多問題</a></div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="chatItemsComponent">
        <!--  Spinner loading indicator -->
        <div v-if="isLoading" class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div v-if="pageType != 'list'" class="reply-form" :class="{'reply-open': showNewReplay,'showReply': showNewReplay}">
          <div v-if="authCheck" class="picIcon">
            <img :src="defaultPicIcon" title="" alt="">
          </div>
          <form v-if="canReply" style="overflow: hidden">
            <div class="input-content">
              <HtmlEditorPro
                  :value="template"
                  :inputName="'messageRender'"
                  :inputNamePic="'Pics'"
              ></HtmlEditorPro>
              <button class="action-btn" :class="{
                'ajaxLoading': ajaxLoading
                }" type="button" :disabled="ajaxLoading" @click.prevent="submitForm">
送出
</button>
            </div>
          </form>
          <a v-else href="user/login" class="promptLoginBtn" title="">請先登入會員</a>
        </div>
        <div v-if="pageType == 'list' && chatItems?.length > 0">
          <div class="chatItems" :class="{'flex-direction-row': columnRow}">
            <chat-item
                v-for="(item, key) in currentChatItems" :key="item.id"
                :chatItem="item"
                :postMaxSize="postMaxSize"
                :uploadMaxSize="uploadMaxSize"
                :maxFileUploads="maxFileUploads"
                :pageType="pageType"
                :showReply="showReply"
                :postUrl="postUrl"
                :authCheck="authCheck"
                :authUserId="authUserId"
                :canReply="canReply"
                :position="position"
                :pagePath="pagePath"
            ></chat-item>
          </div>
          <div v-if="pageType == 'list'" class="pagination">
            <span :class="{active: currentPage === 1, disabled: isLoading}"
          @click="setPage(1)">1</span>
            <span v-if="currentPage > 3"
                  :class="{disabled: isLoading}">...</span>

            <span v-for="page in surroundingPages"
                  :class="{active: currentPage === page, disabled: isLoading}"
                  @click="setPage(page)">{{ page }}</span>

            <span v-if="currentPage < lastPage - 3"
                  :class="{disabled: isLoading}">...</span>
            <span v-if="lastPage > 1" :class="{active: currentPage === lastPage, disabled: isLoading}"
                  @click="setPage(lastPage)">{{ lastPage }}</span>
          </div>
        </div>
        <div v-else-if="pageType == 'newCreate'">
          <div class="chatItems" :class="{'flex-direction-row': columnRow}">
            <chat-item
                :key="0"
                :chatItem="{}"
                :postMaxSize="postMaxSize"
                :uploadMaxSize="uploadMaxSize"
                :maxFileUploads="maxFileUploads"
                :pageType="pageType"
                :showReply="'reply-open'"
                :postUrl="postUrl"
                :authCheck="authCheck"
                :questionTemplate="questionTemplate"
                :authUserId="authUserId"
            ></chat-item>
          </div>
        </div>
        <div v-else-if="pageType == 'read' && chatItems?.length > 0 ">
          <div class="chatItems" :class="{'flex-direction-row': columnRow}">
            <chat-item
                v-for="(item, key) in currentChatItems" :key="item.id"
                :itemKey="key"
                :chatItem="item"
                :postMaxSize="postMaxSize"
                :uploadMaxSize="uploadMaxSize"
                :maxFileUploads="maxFileUploads"
                :pageType="pageType"
                :showReply="showReply"
                :postUrl="postUrl"
                :authCheck="authCheck"
                :canReply="canReply"
                :authUserId="authUserId"
            ></chat-item>
          </div>
          <div class="pagination">
            <span :class="{active: currentPage === 1, disabled: isLoading}"
                  @click="setPage(1)">1</span>
            <span v-if="currentPage > 3"
                  :class="{disabled: isLoading}">...</span>

            <span v-for="page in surroundingPages"
                  :class="{active: currentPage === page, disabled: isLoading}"
                  @click="setPage(page)">{{ page }}</span>

            <span v-if="currentPage < lastPage - 3"
                  :class="{disabled: isLoading}">...</span>
            <span v-if="lastPage > 1" :class="{active: currentPage === lastPage, disabled: isLoading}"
                  @click="setPage(lastPage)">{{ lastPage }}</span>
          </div>
        </div>
        <p v-else class="chat-empty">目前還沒有任何提問</p>
      </div>
    </div>
  </div>
</template>
<script>
import ChatItem from 'Vue/Web/Common/OnlineMedical/ChatItem';
import HtmlEditorPro from 'Vue/Common/HtmlEditor/HtmlEditorPro.vue';

export default {
  name: 'ChatItemsComponent',
  components: {
    HtmlEditorPro,
    ChatItem,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    statement: {
      type: String,
      default: '',
    },
    questionTemplate: {
      type: String,
      default: '',
    },
    canReply: {
      type: Boolean,
      default: false,
    },
    titleh1: {
      type: String,
      default: '',
    },
    lastPage: {
      type: Number,
      default: 10,
    },
    columnRow: {
      type: Boolean,
      default: false,
    },
    chatItems: {
      type: Array,
      default: [],
    },
    pageType: {
      type: String,
      default: 'list',
    },
    position: {
      type: String,
      default: '',
    },
    showReply: {
      type: String,
      default: 'hidden',
    },
    showMore: {
      type: String,
      default: 'hidden',
    },
    showAlert: {
      type: String,
      default: 'hidden',
    },
    postMaxSize: {
      type: Number,
      default: 0,
    },
    uploadMaxSize: {
      type: Number,
      default: 0,
    },
    maxFileUploads: {
      type: Number,
      default: 0,
    },
    fetchUrl: {
      type: String,
      default: '',
    },
    eachPageItemCount: {
      type: Number,
      default: 6,
    },
    postUrl: {
      type: String,
      default: 'onlineMedicalConsultation/post',
    },
    authCheck: {
      type: Boolean,
      default: false,
    },
    authUserId: {
      type: Number,
      default: 0,
    },
    pagePath: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      template: '',
      preloadPages: 5,
      currentPage: 1,
      isLoading: false,
      currentChatItems: [],
      pagesData: {},
      rootId: null,
      defaultPicIcon: 'img/fanswoo-framework/admin/sidebar/headPortrait.jpg',
      replyFormPicIds: [],
      ajaxLoading: false,
      showNewReplay: false,
      formPlaceholder: '發表新提問',
    };
  },
  computed: {
    convertStatement() {
      return this.statement.split('\n').map((line) => `<p>${line}</p>`).join('');
    },
    surroundingPages() {
      const pages = [];
      const start = Math.max(2, this.currentPage - 2);
      const end = Math.min(this.lastPage - 1, this.currentPage + 2);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  mounted() {
    this.currentChatItems = this.chatItems;
    this.pagesData[this.currentPage] = this.chatItems;
    if (this.pageType === 'read') {
      this.rootId = this.chatItems[0].rootId ?? this.chatItems[0].id;
      this.formPlaceholder = '發表新回覆';
    }
    if (this.pageType === 'newCreate') {
      this.template = this.questionTemplate;
      this.showNewReplay = true;
      this.canReply = this.authCheck;
    }
  },
  methods: {
    async fetchChatItems() {
      this.isLoading = true;
      this.currentChatItems = [];
      const itemsPerPage = this.eachPageItemCount;
      const startPage = this.currentPage;
      const endPage = Math.min(this.currentPage - 1 + this.preloadPages, this.lastPage);

      const postData = {
        startPage,
        endPage,
        itemsPerPage,
      };

      if (this.pageType === 'read') {
        postData.rootId = this.rootId;
      }

      try {
        const response = await axios.post(this.fetchUrl, postData);

        for (let i = 0; i < this.preloadPages; i++) {
          const startIndex = i * this.eachPageItemCount;
          const pageData = response.data.slice(startIndex, startIndex + this.eachPageItemCount);
          if (pageData.length > 0) {
            this.$set(this.pagesData, startPage + i, pageData);
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.currentChatItems = this.pagesData[this.currentPage];
        this.isLoading = false;
      }
    },
    async setPage(page) {
      if (this.page > this.lastPage || this.isLoading) {
        return;
      }

      this.currentPage = page;
      if (this.pagesData[this.currentPage]) {
        this.currentChatItems = this.pagesData[this.currentPage];
        return;
      }
      await this.fetchChatItems();
    },
    // eslint-disable-next-line consistent-return
    getUserData(item, key) {
      if (key === 'id') {
        return item?.User?.id ?? -1;
      } if (key === 'name') {
        return item?.User?.name ?? item?.userName;
      } if (key === 'picUrl') {
        return 'img/fanswoo-framework/admin/sidebar/headPortrait.jpg';
      }
    },
    submitForm(event) {
      const messageRender = $(event.currentTarget).parent().find('textarea[name="messageRender"]').val();
      const pics = $(event.currentTarget).parent().find('input[name="Pics[]"]').val();

      if (messageRender === undefined || messageRender.length === 0) {
        global.Message.show({
          text: '請輸入訊息內容...',
        });
        return;
      }
      this.ajaxLoading = true;

      global.Message.show({
        text: '正在送出資料...',
      });

      const formData = new FormData();
      formData.append('messageRender', messageRender);
      if (pics) {
        formData.append('Pics[]', pics);
      }
      if (this.rootId) {
        formData.append('rootId', this.rootId);
      }
      formData.append('pageType', this.pageType);

      axios.post(this.postUrl, formData)
        .then((response) => {
          // 處理成功響應
          axios.post('onlineMedicalConsultation/sentNotification', { id: response.data.parameter.id });
          global.Message.show(response.data);
          this.ajaxLoading = false;
        })
        .catch((error) => {
          // 處理錯誤
          console.error(error);
          this.ajaxLoading = false;
        });
    },
    toggleNewReplay() {
      this.showNewReplay = !this.showNewReplay;
    },
  },
};
</script>
<style scoped lang="scss">
$maincolor:#72ca4a;
$xs: 0px;
$sm: 576px;
$md: 768px;
$lg: 992px;
$xl: 1200px;

.chatItemsComponent {
  width: 100%;
  margin: auto auto 4rem;
  &.outcontent {
    border-bottom: solid 1px #9f9f9f;
  }
  .alert {
    background-color: #d5efc8;
    p {
      margin-bottom: 0rem;
    }
  }
  .reply-form{
    align-items: flex-start;
    position: relative;
    border: solid 1px #bdcab7;
    display: none;
    padding: 1.5rem 0rem 1rem 4rem;
    &.reply-open{
      display: flex;
    }
    .picIcon{
      border-radius: 50%;
      overflow: hidden;
      flex: 0 0 50px;
      max-height: 50px;
    }
    form{
      width: 100%;
    }
    .input-content{
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      padding-left: 2rem;
      padding-right: 2rem;
      textarea{
        height: 220px;
        margin-bottom: 15px;
        width: 100%;
      }
      .action-btn{
        background-color: #72ca4a;
        border: none;
        border-radius: 3px;
        color: #fff;
        display: block;
        height: 40px;
        transition: .3s;
        width: 150px;
        &.ajaxLoading{
          background-color: darken(#72ca4a, 20%);
          cursor: not-allowed;
        }
      }
    }
  }
}
.spinner-border{
  margin: 50px 50%;
}

.disabled {
  pointer-events: none;
  opacity: 0.6;  /* 降低透明度，使其看起來像是被禁用的 */
}
.chatItems.flex-direction-row {
  @media (min-width: 1025px) {
    display: flex;
    flex-wrap: wrap; /* 允許元素換行 */
    margin-top: 20px;
    flex-direction: row;
    .evaluation-sum {
      flex-basis: calc(50% - 10px); /* 設置元素寬度為父元素的一半減去間隔 */
      margin: 5px; /* 設置元素間的間隔 */
    }
  }
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.pagination span {
  margin: 0 5px;
  padding: 5px 10px;
  cursor: pointer;
  border: 1px solid #ddd;
}

.pagination span.active {
  background-color: #72ca4a;
  color: white;
}

.relatedTitleBox {
  margin-bottom: 0rem;
}

.hidden{
  display: none !important;
}

.show{
  display: block;
}

.titleBox {
  padding: 10px 0;

  .title {
    width: 100%;
    font-size: 24px;
    line-height: 40px;
    font-weight: 400;
    border-left: solid 5px $maincolor;
    padding-left: 15px;
    margin-bottom: 12px;

    .prompt {
      display: inline-block;
      width: 16px;
      margin-left: 5px;
    }
  }
  .sub-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.5rem;
    @media (max-width: 768px) {
      flex-direction: column;
    }
    .promptLine {
      &.margin-l-auto {
        margin-left: auto;
      }
      @media (max-width: 768px) {
        &.margin-l-auto {
          margin-top: 1.5rem;
          margin-left: unset;
        }
      }
      .promptBtn {
        display: inline-block;
        color: $maincolor;
        line-height: 19px;
        border-bottom: 1px solid $maincolor;
        cursor: pointer;
        font-size: 18px;
        &:hover {
          color: darken($maincolor, 10%);
          transition: 0.3s;
        }
      }
      .promptLoginBtn {
        color: $maincolor;
      }
      .more, .promptBtn {
        position: relative;
        font-size: 18px;
        line-height: 19px;
        cursor: pointer;
        border-bottom: 1px solid $maincolor;
        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0px;
          width: 50%;
          height: 1px;
        }
        a{
          color: $maincolor;
          &:hover {
            color: darken($maincolor, 10%);
            transition: 0.3s;

            &::after {
              width: 100%;
              background: #72ca4a;
              transition: 0.3s linear;
            }
          }
        }
      }
    }

  }
}

</style>
